export default "__VITE_ASSET__ef9225d9__"